import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Scan, TranAndTraceScan } from '../domain/Scan';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScanService {

    ScansByTrackAndTrace$ = new BehaviorSubject<TranAndTraceScan[]>(new Array<TranAndTraceScan>());
    TrackAndTraceInfomation$ = new BehaviorSubject<Scan[]>([]);

    constructor(private httpClient: HttpClient) {
    }


    // getScansByTrackAndTrace(trackAndTrace: any) {
    //     let queryParams = new HttpParams();
    //     queryParams = queryParams.append('trackAndTrace', trackAndTrace);
    //     return this.httpClient.get(`${environment.apiUrl}/scans/getscansbytrackandtrace`, { params: queryParams });
    // }

    getScansByTrackAndTraceV2(trackAndTrace: string): void {
        this.ScansByTrackAndTrace$.next([]);
        this.httpClient.get<any[]>(`${environment.apiUrl}/e/scans/trackandtrace/${trackAndTrace}`).subscribe(scan => {
            if (scan.length > 0)
                this.ScansByTrackAndTrace$.next(scan);
        });
    }

    // :Observable<Scan>
    getScansByShipmentId(shipmentId: any) {
        let queryParams = new HttpParams();
        queryParams = queryParams.append('shipmentId', shipmentId);
        return this.httpClient.get(`${environment.apiUrl}/scans/getscansbytrackandtrace`, { params: queryParams });
    }

    /**
 * featch shipment tracking infomation to show on trackAndTrace page.
 */
    GetShipmentTrackAndTraceInfomation(trackAndtrace: string) {                
        let host = window.location.hostname.split('.')[0];
        let headers = new HttpHeaders({ tenantIdentifier: host });
        return this.httpClient.get<any>(`${environment.apiUrl}/scans/getscansbytrackandtrace/${trackAndtrace}`, { headers: headers });
    }

    GetShipmentTrackAndTraceInfomationV2(trackAndtrace: string){
        let host = window.location.hostname.split('.')[0];
        let headers = new HttpHeaders({ tenantIdentifier: host });
        return this.httpClient.get<any>(`${environment.apiUrl}/e/scans/getscanstrackandtracepage/${trackAndtrace}`, { headers: headers });
    }
}

